import React from 'react';
import { Helmet } from 'react-helmet';
import PageNav from '../om-oss-about-us/components/PageNav';
import ServicesHero from './components/ServicesHero';
import ServiceFeatures from './components/ServiceFeatures';
import PricingTiers from './components/PricingTiers';
import UseCases from './components/UseCases';

const TjenesterServices = () => {
  return (
    <>
      <Helmet>
        <title>Tjenester — NordPass | Veikart, Bomkalkulator & Mer</title>
        <meta name="description" content="Utforsk NordPass sine tjenester: interaktivt veikart, presis bomkalkulator, kjøretøyadministrasjon og fleksible abonnementer for norske sjåfører." />
        <link
          href="https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=Lora:ital,wght@0,400;0,700;1,400;1,700&family=Inter:wght@300;400;500;600&family=JetBrains+Mono:wght@400;500;700&display=swap"
          rel="stylesheet" />
        
      </Helmet>
      <div style={{ background: '#050A12', minHeight: '100vh', overflowX: 'hidden' }}>
        <PageNav />
        <ServicesHero />
        <ServiceFeatures />
        <UseCases />
        <PricingTiers />

        {/* CTA strip */}
        <section style={{
          position: 'relative',
          overflow: 'hidden',
          padding: '0'
        }}>
          <div style={{ position: 'relative', height: '400px', overflow: 'hidden' }}>
            <img
              src="https://images.unsplash.com/photo-1688533556606-ec9ce7bcf64f"
              alt="Norwegian mountain road at night with dramatic sky and car headlights illuminating the path ahead"
              style={{ width: '100%', height: '100%', objectFit: 'cover', filter: 'brightness(0.25) contrast(1.2)' }} />
            
            <div style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '32px',
              padding: '0 5%'
            }}>
              <h2 style={{
                fontFamily: 'Syne, sans-serif',
                fontSize: 'clamp(2rem, 4vw, 3.5rem)',
                fontWeight: 800,
                color: '#EEF0F2',
                letterSpacing: '-0.04em',
                textAlign: 'center',
                margin: 0
              }}>KLAR FOR Å STARTE?</h2>
              <p style={{
                fontFamily: 'Lora, serif',
                fontStyle: 'italic',
                fontSize: '1.125rem',
                color: 'rgba(238,240,242,0.7)',
                textAlign: 'center',
                maxWidth: '500px',
                margin: 0
              }}>Bli med 47.000+ norske sjåfører som allerede bruker NordPass.</p>
              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
                <a href="/login" style={{
                  fontFamily: 'Syne, sans-serif',
                  fontSize: '0.875rem',
                  fontWeight: 700,
                  color: '#EEF0F2',
                  textDecoration: 'none',
                  padding: '14px 32px',
                  background: '#3B6FD4',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase'
                }}>START GRATIS</a>
                <a href="/nord-pass-contact-page" style={{
                  fontFamily: 'Syne, sans-serif',
                  fontSize: '0.875rem',
                  fontWeight: 700,
                  color: '#EEF0F2',
                  textDecoration: 'none',
                  padding: '14px 32px',
                  border: '2px solid rgba(238,240,242,0.3)',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase'
                }}>KONTAKT OSS</a>
              </div>
            </div>
          </div>
        </section>

        {/* Simple footer */}
        <footer style={{ background: '#050A12', padding: '40px 5%', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
          <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
            <div style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.6875rem', color: 'rgba(138,149,163,0.4)', letterSpacing: '0.06em' }}>
              © 2026 NordPass AS — Alle rettigheter forbeholdt
            </div>
            <div style={{ display: 'flex', gap: '24px' }}>
              {[
              { label: 'Hjem', href: '/nord-pass-landing-page' },
              { label: 'Om Oss', href: '/om-oss-about-us' },
              { label: 'Kontakt', href: '/nord-pass-contact-page' }]?.
              map((link, i) =>
              <a key={i} href={link?.href} style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '0.75rem',
                color: 'rgba(138,149,163,0.4)',
                textDecoration: 'none'
              }}>{link?.label}</a>
              )}
            </div>
          </div>
        </footer>
      </div>
    </>);

};

export default TjenesterServices;